import React from "react";

import "./App.scss";
import Footer from "./components/Footer";
import Header from "./components/Header";
import ButtonContainer from "./components/ButtonContainer";
import MapComponent from "./components/MapComponent";
import { getActiveBuses, initialData } from "./helpers/actions";
import { fetchInterval, linksObject } from "./landPageConfig";
import {
  getBctBuses,
  getBCTExtents,
  getGlobalCoordinates,
  getMsBuses,
  getMsExtents,
  getPbBuses,
  getPbExtents,
} from "./helpers/utils";

function App(): JSX.Element {
  const [mapRange, setMapRange] = React.useState<MapRange | null>(null);
  const [agencyArray, setAgencyArray] = React.useState<AgencyArray[] | null>(null);
  const [agencyDataArray, setAgencyDataArray] = React.useState<BusInfo[] | null>(null);
  const [msAgencyId, setMSAgencyId] = React.useState<string>("");
  const [pbAgencyId, setPBAgencyId] = React.useState<string>("");

  React.useEffect(() => {
    const getInitialData = async (): Promise<void> => {
      const initialDataToSet = await initialData();
      // console.log("initialDataToSet:", initialDataToSet);

      const msData: { extentsToReturn: MapRange; msAgencyId: string } = await getMsExtents();
      const pbData: { extentsToReturn: MapRange; pbAgencyId: string } = await getPbExtents();
      const mctData: { extentsToReturn: MapRange; pbAgencyId: string } = await getBCTExtents();

      const mapRangeFromApi = (initialDataToSet?.initialMapRange as MapRange) || {};
      const agencyArrayFromApi = initialDataToSet?.agencyArray || "";

      const globalLatLonSpan: MapRange = getGlobalCoordinates([
        mapRangeFromApi,
        msData?.extentsToReturn,
        pbData?.extentsToReturn,
        mctData?.extentsToReturn,
      ]);
      // console.log("globalLatLonSpan:", globalLatLonSpan);

      setMapRange(globalLatLonSpan); //* TA not MS and PB!
      setAgencyArray(agencyArrayFromApi); //* TA not MS and PB!
      setMSAgencyId(msData?.msAgencyId); //* MS
      setPBAgencyId(pbData?.pbAgencyId); //* PB
    };
    getInitialData();
  }, []);

  React.useEffect(() => {
    if (agencyArray && msAgencyId && pbAgencyId) {
      //* promise.AllSettled unnecessary here
      const getAllBuses = async (): Promise<void> => {
        const busesObjectArray = [] as BusInfo[];
        for (let i = 0; i < agencyArray.length; i++) {
          const busesFromApi = await getActiveBuses(agencyArray[i].agencyId);
          await busesObjectArray.push(...busesFromApi);
        }
        // console.log("Data was fetched at", new Date().toLocaleString());
        const msBuses: BusInfo[] = await getMsBuses(msAgencyId, linksObject?.[4]?.name);
        if (msBuses) {
          await busesObjectArray.push(...msBuses);
        }

        const pbBuses: BusInfo[] = await getPbBuses(pbAgencyId, linksObject?.[5]?.name);
        if (pbBuses) {
          await busesObjectArray.push(...pbBuses);
        }

        const bctBuses: BusInfo[] = await getBctBuses(pbAgencyId, linksObject?.[6]?.name);
        if (bctBuses) {
          await busesObjectArray.push(...bctBuses);
        }

        // console.log("busesObjectArray:", busesObjectArray);
        setAgencyDataArray(busesObjectArray);
      };
      getAllBuses();
      const fetchingInterval = setInterval(getAllBuses, fetchInterval) as NodeJS.Timer;
      // console.log({ fetchingInterval });
      return () => {
        clearInterval(fetchingInterval);
        // console.log("Interval was cleared");
      };
    }
  }, [agencyArray, msAgencyId, pbAgencyId]);

  return (
    <React.Fragment>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <div className="col-3">
            <ButtonContainer />
          </div>
          <div className="col-9">
            {mapRange && agencyDataArray && agencyArray ? (
              <MapComponent mapRange={mapRange} agencyDataArray={agencyDataArray} agencyArray={agencyArray} />
            ) : null}
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}

export default App;
